import { preview } from '@/components/form/preview'
import { useTexts } from './useTexts'

type Props = {
  driverAssistance: uui.domain.server.rm.MobileAppInteraction
}

export function DriverAssistanceType(props: Props) {
  const texts = useTexts()
  const { driverAssistance } = props
  const isInOutSuggestType = driverAssistance.type === 'ASSISTED_TIME_IN_OUT'
  const isOutSuggestType = driverAssistance.type === 'ASSISTED_TIME_OUT'
  const isRequireType = driverAssistance.type === 'DRIVER_REQUIRED_FLOW'
  const type =
    isInOutSuggestType || isOutSuggestType
      ? texts.suggest
      : isRequireType
        ? texts.require
        : texts.off
  const isSuggestType = isInOutSuggestType || isOutSuggestType

  return (
    <>
      <preview.Field label={texts.header}>{type}</preview.Field>

      {(isSuggestType || isRequireType) && (
        <preview.Section>
          <preview.SectionTitle variant="alternative">{texts.actions}</preview.SectionTitle>

          {isSuggestType && (
            <>
              {isInOutSuggestType && (
                <preview.Field label={texts.checkIn} testId="check-in">
                  {texts.ALWAYS_REQUIRED}
                </preview.Field>
              )}
              <preview.Field label={texts.checkOut} testId="check-out">
                {texts.ALWAYS_REQUIRED}
              </preview.Field>
            </>
          )}

          {isRequireType && (
            <>
              <preview.Field label={texts.checkIn} testId="check-in">
                {texts.ALWAYS_REQUIRED}
              </preview.Field>

              <preview.Field label={texts.orderStatus} testId="order-status">
                {texts.ALWAYS_REQUIRED}
              </preview.Field>

              {Object.entries(driverAssistance.driverRequiredFlow).map(entry =>
                entry[0] !== 'mandatoryDeparture' && entry[1] !== 'DO_NOT_REQUIRE' ? (
                  <preview.Field label={texts[entry[0]]} key={entry[0]} testId={entry[0]}>
                    {texts[entry[1]]}
                  </preview.Field>
                ) : entry[0] === 'mandatoryDeparture' && entry[1] ? (
                  <preview.Field label={texts.checkOut} key={entry[0]} testId="check-out">
                    {texts.ALWAYS_REQUIRED}
                  </preview.Field>
                ) : null,
              )}
            </>
          )}
        </preview.Section>
      )}
    </>
  )
}
